import type { email_aziendale, user } from '@/model/qsadminapi/QsAdminApiModuleModel'

export const EMAIL_REGEX =
  /^(([^\s"(),.:;<>@[\\\]]+(\.[^\s"(),.:;<>@[\\\]]+)*)|(".+"))@((\[(?:\d{1,3}\.){3}\d{1,3}])|(([\dA-Z\\a-z-]+\.)+[A-Za-z]{2,}))$/

export const createAdditionalEmailItem = (email: string, note: string | null = null): email_aziendale => ({
  id: 0,
  email,
  note,
  rif_ad: false,
})

export const normalizeAdditionalEmailItems = (items: Array<Partial<email_aziendale> | null | undefined>) => {
  const uniqueEmails = new Map<string, email_aziendale>()

  items.forEach((item) => {
    const email = item?.email?.trim()
    if (!item || !email) return

    const key = email.toLowerCase()
    if (uniqueEmails.has(key)) return

    uniqueEmails.set(key, {
      id: typeof item.id === 'number' ? item.id : 0,
      email,
      note: item.note ?? null,
      rif_ad: item.rif_ad ?? false,
    })
  })

  return [...uniqueEmails.values()]
}

export const mapUserToAdditionalEmailItem = (employee: user) => {
  const email = employee.email?.trim()
  return email ? createAdditionalEmailItem(email, employee.fullname ?? null) : null
}

export const buildAdditionalEmailDataSourceItems = (
  ticketAdditionalEmails: email_aziendale[] | null | undefined,
  employees: user[],
) => normalizeAdditionalEmailItems([...(ticketAdditionalEmails ?? []), ...employees.map(mapUserToAdditionalEmailItem)])

export const containsEmail = (items: Array<Partial<email_aziendale> | null | undefined>, email: string) => {
  const key = email.trim().toLowerCase()
  return items.some((item) => item?.email?.trim().toLowerCase() === key)
}

export const isAdditionalEmailValid = (email: string, referenceEmail: string | null | undefined) => {
  const trimmedEmail = email.trim()
  const isReferenceEmail = referenceEmail?.trim().toLowerCase() === trimmedEmail.toLowerCase()

  return EMAIL_REGEX.test(trimmedEmail) && !isReferenceEmail
}

export const resolveAdditionalEmailCustomItem = ({
  text,
  referenceEmail,
  currentValues,
  dataSourceItems,
}: {
  text: string | null | undefined
  referenceEmail: string | null | undefined
  currentValues: Array<Partial<email_aziendale> | null | undefined>
  dataSourceItems: email_aziendale[]
}) => {
  const newValue = text?.trim()
  if (!newValue || !isAdditionalEmailValid(newValue, referenceEmail) || containsEmail(currentValues, newValue)) {
    return null
  }

  return (
    dataSourceItems.find((email) => email.email?.trim().toLowerCase() === newValue.toLowerCase()) ??
    createAdditionalEmailItem(newValue)
  )
}
